import React from 'react';
const painPoints = ['Llegás al lunes sin saber exactamente qué actividad vas a hacer en la sesión de las 9', 'Tus pacientes no progresan porque no tenés una secuencia clara de hitos y objetivos por etapa', 'Las familias te preguntan "¿cómo va mi hijo?" y no tenés un informe claro para mostrar', 'Buscás actividades en Pinterest a las 23:00 del domingo y terminás usando siempre las mismas', 'No podés justificar un aumento de honorarios porque no tenés un sistema profesional visible', 'Siempre las mismas actividades improvisadas, sin progresión ni fundamento clínico real'];
export function PainPoints() {
  return <section className="w-full px-4 py-10 text-gray-900 text-base leading-6" style={{
    backgroundColor: 'rgb(254, 242, 242)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-174">
      <div className="mx-auto max-w-3xl" data-id="element-175">
        {/* Section Title */}
        <p className="text-center text-xs sm:text-sm font-bold tracking-[2px] uppercase text-red-500 mb-2" data-id="element-176">
          ¿Te sentís identificada?
        </p>
        <h2 className="text-center text-2xl sm:text-3xl font-black text-gray-900 m-0 mb-6" data-id="element-177">
          Esto le pasa al 90% de las profesionales
        </h2>

        {/* Pain Points Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8" data-id="element-178">
          {painPoints.map((point, i) => <div key={i} className="flex items-start gap-2 bg-white border border-red-200 rounded-lg p-3 shadow-sm" data-id="element-179">
              <span className="text-red-500 text-base leading-5 shrink-0" data-id="element-180">
                ✗
              </span>
              <p className="text-xs sm:text-sm text-gray-800 m-0" data-id="element-181">{point}</p>
            </div>)}
        </div>

        {/* Bottom CTA */}
        <p className="text-center text-xl sm:text-2xl font-black text-cyan-brand m-0 mb-6" data-id="element-182">
          ¿Cuántas sesiones más vas a improvisar?
        </p>

        {/* Divider */}
        <div className="h-px w-full" style={{
        backgroundImage: 'linear-gradient(to right, rgba(255, 255, 255, 0), rgb(0, 180, 216), rgba(255, 255, 255, 0))'
      }} data-id="element-183" />
      </div>
    </section>;
}